module.exports = __webpack_public_path__ + "img/capa.14c5e925.jpg";